import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("elt_cookie_notice")) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("elt_cookie_notice", "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 z-50 sm:left-5 sm:right-auto sm:max-w-md"
          data-testid="cookie-banner"
        >
          <div className="border border-line bg-panel/95 shadow-2xl backdrop-blur-xl">
            <div className="hazard-stripes h-1 w-full" />
            <div className="p-5">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-brass">Cookie Notice</p>
              <p className="mt-2 text-sm leading-relaxed text-[#9CA3AF]">
                This site uses only essential cookies and storage needed for basic functionality — no advertising trackers. Details in our{" "}
                <Link to="/privacy" data-testid="cookie-privacy-link" className="text-hazard hover:underline">Privacy Policy</Link>.
              </p>
              <button
                data-testid="cookie-accept-btn"
                onClick={accept}
                className="mt-4 w-full bg-hazard px-4 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-asphalt transition-colors hover:bg-hazard-dark sm:w-auto"
              >
                Got It
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
